import {NgModule, provideZonelessChangeDetection} from '@angular/core';
import {AcknowledgedMessageProcessor} from './acknowledged-message-processor';
import {EntryMessageProcessor} from './entry-message-processor';
import {LicenseMessageProcessor} from './license-message-processor';
import {PongMessageProcessor} from './pong-message-processor';
import {VoidMessageProcessor} from './void-message-processor';
import {WebsocketMessageProcessor} from './websocket-message-processor';
import {EntryFetchMessageProcessor} from './entry-fetch-message-processor';
import {WSMessageReceiverService} from '@services/ws-message-receiver.service';
import {ErrorMessageProcessor} from './error-message-processor';
import {ReceiveEventAcknowledgementAction} from '@actions/receive-event-acknowledgement.action';
import {UserStatsFetchMessageProcessor} from './user-stats-fetch-message-processor';
import {UserDetailsMessageProcessor} from './user-details-message-processor';
import {ReceiveEventSuccessAction} from '@app/actions/receive-event-success.action';
import {AIStreamingMessageProcessor} from './ai-streaming-message-processor';
import {AgentStreamMessageProcessor} from './agent-stream-message-processor';
import {ScormMessageProcessor} from './scorm-message-processor';
import {EntryDeactivatedMessageProcessor} from './entry-deactivated-message-processor';
import {AIScoresMessageProcessor} from './ai-scores-message-processor';
import {AIAnswersAndRubricsMessageProcessor} from './ai-answers-and-rubrics-message-processor';

@NgModule({
  declarations: [],
  imports: [],
  providers: [
    provideZonelessChangeDetection(),
    VoidMessageProcessor,
    PongMessageProcessor,
    EntryMessageProcessor,
    LicenseMessageProcessor,
    AcknowledgedMessageProcessor,
    WSMessageReceiverService,
    EntryFetchMessageProcessor,
    ErrorMessageProcessor,
    ReceiveEventAcknowledgementAction,
    ReceiveEventSuccessAction,
    UserStatsFetchMessageProcessor,
    UserDetailsMessageProcessor,
    AIStreamingMessageProcessor,
    AgentStreamMessageProcessor,
    ScormMessageProcessor,
    EntryDeactivatedMessageProcessor,
    AIScoresMessageProcessor,
    AIAnswersAndRubricsMessageProcessor,
    {
      provide: 'wsMessageProcessors',
      useFactory: (...mps: Array<WebsocketMessageProcessor>) => mps,
      deps: [
        VoidMessageProcessor,
        AcknowledgedMessageProcessor,
        EntryMessageProcessor,
        PongMessageProcessor,
        // TODO I think this class is currently only useful for  some obscure feature
        // nobody knows anything about, but if you remove it will break it.
        // Licenses are processed by the entry message processor
        LicenseMessageProcessor,
        EntryFetchMessageProcessor,
        UserStatsFetchMessageProcessor,
        UserDetailsMessageProcessor,
        ErrorMessageProcessor,
        AIStreamingMessageProcessor,
        AgentStreamMessageProcessor,
        ScormMessageProcessor,
        EntryDeactivatedMessageProcessor,
        AIScoresMessageProcessor,
        AIAnswersAndRubricsMessageProcessor,
      ],
    },
  ],
})
export class DispatcherModule {}
